<template>
  <div :class="cmp_class">
    <div class="grey">
      <v-img :src="promotion.thumbnail_url" :height="size" :width="size" grey>
      </v-img>
    </div>
    <div
      class="flex-grow-1x d-flex flex-column justify-space-between"
      :style="'heightx:' + size + ';'"
    >
      <div class="redx">
        <div class="left-text pt-2 pl-2 pr-2">
          <h3>{{ promotion.title }}</h3>
        </div>
        <div class="left-text pt-2 pl-2 pr-2 d-flex justify-space-between mb-2">
          <div>
            <v-icon>mdi-calendar</v-icon>
            Start Date: <b>{{ promotion.starts_on }}</b>
          </div>
          <div>
            <v-icon>mdi-calendar</v-icon>
            End Date: <b>{{ promotion.ends_on }}</b>
          </div>
          <div>
            <v-icon>mdi-info</v-icon>
            <span class="red--text" v-if="promotion.expiry == 'expired'"
              ><b>Has Expired</b></span
            >
            <span class="warning--text" v-if="promotion.expiry == 'pending'"
              ><b>Not Yet Started</b></span
            >
            <span
              class="success--text"
              v-if="
                promotion.expiry == 'live' &&
                parseInt(promotion.has_been_ended) == 0
              "
              ><b>Happening Now</b></span
            >
            <span
              class="red--text"
              v-if="
                promotion.expiry == 'live' &&
                parseInt(promotion.has_been_ended) == 1
              "
              ><b>Was Ended</b></span
            >
          </div>
        </div>
        <v-divider></v-divider>
      </div>
      <div
        class="text-left pt-2 pl-2 pr-2 d-flex justify-start pt-2 pb-2 bluex"
      >
        <div class="mr-5">
          <v-icon>md-eye</v-icon>
          Views:
          <span class="info--text"
            ><b>{{ promotion.views_count }}</b></span
          >
        </div>
        <div class="mr-5">
          Status:
          <span class="red--text" v-if="parseInt(promotion.has_been_ended) == 1"
            ><b>Ended</b></span
          >
          <span
            class="green--text"
            v-if="parseInt(promotion.has_been_ended) == 0"
            ><b>Active</b></span
          >
        </div>
        <div>
          By:
          <v-btn
            small
            text
            class="mr-2 ml-2"
            :to="business_link"
            :disabled="is_loading"
            color="primary"
          >
            <span class="text-decoration-underline"
              >{{ promotion.business.name }}
            </span>
          </v-btn>
        </div>
      </div>
      <div class="text-left pt-2 pl-2 pr-2 yellowx">
        {{ promotion.description }}
      </div>
      <div class="text-right pb-2 pt-2 pr-4" v-if="is_in_public_view == true">
          <v-btn
          rounded
          outlined
          small
          color="success"
          :disabled="is_loading"
          :to="'/promotions/'+promotion.id"
        >
          <v-icon>mdi-eye</v-icon>
          View Promotion 
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "./../lib/Utils";
export default {
  name: "PromotionHeader",
  props: {
    cmp_class: {
      type: String,
      default: "d-flex justify-space-between",
    },
    size: {
      type: [String, Number],
      default: 240,
    },
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_owner_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
    promotion: {
      type: Object,
      default: function () {
        return Utils.get_default_promotion();
      },
      required: true,
    },
  },
  computed: {
    business_link() {
      var lnk = "";
      if (this.is_in_admin_view == true) {
        lnk = "/admin/businesses/list/view/" + this.promotion.business.id;
      } else if (this.is_owner_view == true) {
        lnk = "/owner/businesses/list/view/" + this.promotion.business.id;
      } else {
        lnk = "/businesses/" + this.promotion.business.id;
      }
      return lnk;
    },
  },
};
</script>